import React from "react";
import { Helmet } from "react-helmet";

const DepositSEO = () => {
  return (
    <Helmet>
      {/* Page title */}
      <title>Betpro Wallet Deposit - Fast and Secure Deposits</title>

      {/* Favicon */}
      <link rel="icon" href="https://betprowallet.pk/favicon.ico" />

      {/* Canonical URL */}
      <link rel="canonical" href="https://betprowallet.pk/deposit" />

      {/* Meta tags */}
      <meta
        name="description"
        content="Deposit funds securely into your Betpro Wallet account. ⚽️ Fast and easy deposits with multiple payment options. Start betting now with Betprowallet.pk - Safe, reliable, and instant transactions."
      />

      <meta
        name="keywords"
        content="Betpro Wallet deposit, fast deposits, secure deposits, deposit funds Betpro Wallet, Betpro Wallet payment options, deposit betting account, Betprowallet.pk deposit"
      />

      <meta name="author" content="Betpro Wallet" />

      {/* Open Graph tags */}
      <meta property="og:title" content="Betpro Wallet Deposit - Fast and Secure Deposits" />
      <meta
        property="og:description"
        content="Deposit funds into your Betpro Wallet account securely and quickly. Choose from multiple payment options for a safe betting experience at Betprowallet.pk."
      />
      <meta property="og:url" content="https://betprowallet.pk/deposit" />
      <meta property="og:type" content="website" />
      <meta property="og:image" content="https://betprowallet.pk/bpthumb1.jpg" />

      {/* Twitter Card */}
      <meta name="twitter:card" content="summary_large_image" />
      <meta name="twitter:title" content="Betpro Wallet Deposit - Fast and Secure Deposits" />
      <meta
        name="twitter:description"
        content="Deposit funds easily and securely into your Betpro Wallet account. Instant transactions and multiple payment methods for fast deposits at Betprowallet.pk."
      />
      <meta name="twitter:image" content="https://betprowallet.pk/bpthumb1.jpg" />

      {/* Structured Data */}
      <script type="application/ld+json">
        {JSON.stringify({
          "@context": "https://schema.org",
          "@type": "WebPage",
          name: "Betpro Wallet Deposit",
          url: "https://betprowallet.pk/deposit",
          description:
            "Deposit funds into your Betpro Wallet account securely. Enjoy fast deposits with multiple payment options for a smooth betting experience.",
          publisher: {
            "@type": "Organization",
            name: "Betpro Wallet",
          },
        })}
      </script>
    </Helmet>
  );
};

export default DepositSEO;
